import React, { MouseEventHandler } from 'react';
import { useNavigate, Link } from "react-router-dom";
import { useDidMountEffect } from '@/hooks/useDidMountEffect';
import signOut from '../../auth/api/signOut';
import Facility from '../../shared/types/Facility';
import clearLocalStorage from '@/utils/clearLocalStorage';

type HeaderProps = {
  facility?: Facility;
}

const Header: React.FC<HeaderProps> = ({
  facility
}) => {
  const navigate = useNavigate();
  const handleClick: MouseEventHandler<HTMLAnchorElement> = (e) => {
    e.preventDefault();
    signOut();

    clearLocalStorage();

    navigate('/facility/welcome');
  };

  const addClassHtml = () => {
    var element = document.documentElement; // <html> タグを取得
    if (element) {
      element.classList.toggle("ov");
    }
  };

  useDidMountEffect (() => {
    //accdiron menu
    var acc = document.getElementsByClassName("main-header__nav-click");
    var i;

    if (facility && facility.isPromoCare) {
      var PromoCare = acc[2] as HTMLElement | null;
      if (PromoCare && PromoCare.parentElement) {
        PromoCare.parentElement.style.display = "block";
      }
    }

    if (facility && facility.isFlatRate) {
      var flatRate = acc[3] as HTMLElement | null;
      if (flatRate && flatRate.parentElement) {
        flatRate.parentElement.style.display = "block";
      }
    }
    if (facility && facility.isFacilityFlatRate) {
      var facilityFlatRate = acc[4] as HTMLElement | null;
      if (facilityFlatRate && facilityFlatRate.parentElement) {
        facilityFlatRate.parentElement.style.display = "block";
      }
    }

    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function(this: HTMLElement) {
        this.classList.toggle("active");
        var panel = this.nextElementSibling as HTMLElement | null;
        if (panel) {
          if (panel.style.display === "block") {
            panel.style.display = "";
          } else {
            panel.style.display = "block";
          }
        }
      });
    }

    //click show menu
    var icons02 = document.querySelectorAll('.main-header__mobile-icon');
    icons02.forEach(icon => {
      icon.addEventListener('click', function(e) {
        const target = e.target as HTMLElement;
        const closestIcon = target.closest('.main-header__mobile-icon');
        if (closestIcon) {
          closestIcon.classList.toggle('mobile-close');
        }
      });
    });

    const acc02 = document.getElementsByClassName("main-header__mobile-icon");
    Array.from(acc02).forEach((currentElement) => {
      currentElement.addEventListener("click", () => {
        currentElement.classList.toggle("mobile-close");
      });
    });

    Array.from(acc02).forEach((currentElement) => {
      currentElement.addEventListener("click", () => {
        currentElement.classList.toggle("mobile-close");
        const panel02 = currentElement.nextElementSibling as HTMLElement | null;
        if (panel02) {
          panel02.style.display = panel02.style.display === "block" ? "none" : "block";
        }
      });
    });

    var closeClick = document.getElementsByClassName("main-header__close");
    var x;
    for (x = 0; x < closeClick.length; x++) {
      closeClick[x].addEventListener("click", function(this: HTMLElement) {
        this.classList.toggle("active");
        var panel = this.parentElement as HTMLElement;
        if (panel.style.display === "block") {
          panel.style.display = "none";
        } else {
          panel.style.display = "block";
        }
        if (panel.previousElementSibling instanceof HTMLElement) {
          panel.previousElementSibling.classList.toggle('mobile-close');
        }
      });
    }

    //sidevar menu fixed
    var sections = document.querySelectorAll('.js-item');
    var navLinks = document.querySelectorAll('.js-scroll a');
    window.onscroll = () => {
      sections.forEach((sec) => {
        if (!(sec instanceof HTMLElement)) return;
        var top = window.scrollY;
        var offset = sec.offsetTop + 220;
        var height = sec.offsetHeight;
        var id = sec.getAttribute('id');
        if (top >= offset && top < offset + height) {
          navLinks.forEach((link) => {
            if (!(link instanceof HTMLElement)) return;
            link.classList.remove('active');
            if (id) {
              var activeLink = document.querySelector(`.js-scroll a[href*="${id}"]`);
              if (activeLink instanceof HTMLElement) {
                activeLink.classList.add('active');
              }
            }
          });
        }
      });
    };
  }, [])

  return (
    <React.Fragment>
      <header id="main-header" className="main-header main-header--page">
        <div className="main-header__inner">
          <Link to='/facility/top' className="main-header__logo">
            <picture>
              <source srcSet={`${process.env.PUBLIC_URL}/img/webp/common/logo-sp.webp`} media="(max-width:834px)" type="image/webp" />
              <source srcSet={`${process.env.PUBLIC_URL}/img/common/logo-sp.png`} media="(max-width:834px)" />
              <source srcSet={`${process.env.PUBLIC_URL}/img/webp/common/logo.webp`} type="image/webp" />
              <img src={`${process.env.PUBLIC_URL}/img/common/logo.png`} alt="SEED" />
            </picture>
          </Link>
          <nav className="main-header__navGlobal">
            <ul className="main-header__menu">
              <li className="main-header__menu-item">
                <span className="no-link">{facility?.name}</span>
              </li>
              <li className="main-header__menu-item pc-xl">
                <Link to="">施設情報の確認・変更</Link>
                <div className="accordion"></div>
                <ul className="main-header__submenu">
                  <li className="main-header__submenu-item"><Link to="/facility/confirm">施設情報の確認</Link></li>
                  <li className="main-header__submenu-item"><Link to="/facility/change_mail">メールアドレス・パスワードの変更</Link></li>
                </ul>
              </li>
              <li className="main-header__menu-item pc-xl"><Link to="" className="opacity-link" onClick={handleClick}>ログアウト</Link></li>
              <li className="main-header__menu-item main-header__menu-item--contact pc-xl">
                <Link to="/facility/contact" className="c-btn__01">お問い合わせ</Link>
              </li>
            </ul>
          </nav>
        </div>
        <span className="main-header__mobile-icon"
          onClick={addClassHtml}
          onKeyPress={(e) => {
            if(e.key === "Enter") {
              addClassHtml();
            }
          }}
        >
          <span className="main-header__mobile-icon-border"></span>
          <span className="main-header__mobile-icon-border"></span>
          <span className="main-header__mobile-icon-border"></span>
        </span>
        <div className="main-header__main">
          <ul className="main-header__nav">
            <li className="main-header__nav-item">
              <div className="main-header__nav-click"> 在庫確認 <span className="accordion"></span></div>
              <ul className="main-header__children" style={{display: /\/facility\/stock$/.test(window.location.pathname) ? 'block' : '' }}>
                <li className={`main-header__children-item ${/\/facility\/stock$/.test(window.location.pathname) ? 'active' : ''}`}>
                  <Link to="/facility/stock">在庫確認</Link>
                </li>
              </ul>
            </li>
            <li className="main-header__nav-item">
              <div className="main-header__nav-click"> 注文履歴 <span className="accordion"></span></div>
              <ul className="main-header__children" style={{display: /\/facility\/orders\/history$/.test(window.location.pathname) ? 'block' : '' }}>
                <li className={`main-header__children-item ${/\/facility\/orders\/history$/.test(window.location.pathname) ? 'active' : ''}`}>
                  <Link to="/facility/orders/history">注文履歴</Link>
                </li>
              </ul>
            </li>
            <li className="main-header__nav-item">
              <div className="main-header__nav-click">レンズ注文 <span className="accordion"></span></div>
              <ul className="main-header__children" style={{display: /^\/facility\/orders\/(index|commercial_lens(\/(confirm|complete))?|trial_lens(\/(confirm|complete))?|flat_rate_lens(\/(confirm|complete))?|facility_lens(\/(confirm|complete))?)$/.test(window.location.pathname) ? 'block' : '' }}>
                <li className={`main-header__children-item ${/\/facility\/orders\/index?$/.test(window.location.pathname) ? 'active' : ''}`}>
                  <Link to="/facility/orders/index">一覧</Link>
                </li>
                <li className={`main-header__children-item ${/\/facility\/orders\/commercial_lens(\/confirm|\/complete)?$/.test(window.location.pathname) ? 'active' : ''}`}>
                  <Link to="/facility/orders/commercial_lens">製品レンズ</Link>
                </li>
                <li className={`main-header__children-item ${/\/facility\/orders\/trial_lens(\/confirm|\/complete)?$/.test(window.location.pathname) ? 'active' : ''}`}>
                  <Link to="/facility/orders/trial_lens">トライアルレンズ</Link>
                </li>
                {facility?.isFlatRate &&
                  <li className={`main-header__children-item ${/\/facility\/orders\/flat_rate_lens(\/confirm|\/complete)?$/.test(window.location.pathname) ? 'active' : ''}`}>
                    <Link to="/facility/orders/flat_rate_lens">定額制レンズ</Link>
                  </li>
                }
                { facility?.isFacilityFlatRate &&
                  <li className={`main-header__children-item ${/\/facility\/orders\/facility_lens(\/confirm|\/complete)?$/.test(window.location.pathname) ? 'active' : ''}`}>
                    <Link to="/facility/orders/facility_lens">施設型定額制レンズ</Link>
                  </li>
                }
              </ul>
            </li>
            <li className="main-header__nav-item" style={{display: facility?.isPromoCare ? 'block' : 'none'}}>
              <div className="main-header__nav-click">
                ケア用品・販促品注文 <span className="accordion"></span>
              </div>
              <ul className="main-header__children" style={{display: /\/facility\/orders\/promo_care(\/.*)?/.test(window.location.pathname) ? 'block' : '' }}>
                <li className={`main-header__children-item ${/\/facility\/orders\/promo_care(\/confirm|\/complete)?$/.test(window.location.pathname) ? 'active' : ''}`}>
                  <Link to="/facility/orders/promo_care">ケア用品・販促品注文</Link>
                </li>
              </ul>
            </li>
            <li className="main-header__nav-item" style={{display: 'none'}}>
              <div className="main-header__nav-click">
                定額制契約 <span className="accordion"></span>
              </div>
              <ul className="main-header__children" style={{display: /\/facility\/flat_rates(\/.*)?/.test(window.location.pathname) ? 'block' : '' }}>
                <li className={`main-header__children-item ${/\/facility\/flat_rates\/index?$/.test(window.location.pathname) ? 'active' : ''}`}>
                  <Link to="/facility/flat_rates/index">一覧</Link>
                </li>
                <li className={`main-header__children-item ${/\/facility\/flat_rates\/registration(\/confirm|\/complete)?$/.test(window.location.pathname) ? 'active' : ''}`}>
                  <Link to="/facility/flat_rates/registration">新規契約申込</Link>
                </li>
                <li className={`main-header__children-item ${/\/facility\/flat_rates\/customers(\/[\w-]*)?$/.test(window.location.pathname) ? 'active' : ''}`}>
                  <Link to="/facility/flat_rates/customers">お客様情報変更申込</Link>
                </li>
                <li className={`main-header__children-item ${/\/facility\/flat_rates\/terminate_cancels(\/[\w-]*)?$/.test(window.location.pathname) ? 'active' : ''}`}>
                  <Link to="/facility/flat_rates/terminate_cancels">解約・キャンセル申込</Link>
                </li>
                <li className={`main-header__children-item ${/\/facility\/flat_rates\/lost_non_warranty(\/[\w-]*)?$/.test(window.location.pathname) ? 'active' : ''}`}>
                  <Link to="/facility/flat_rates/lost_non_warranty">紛失・保証外レンズ申込</Link>
                </li>
              </ul>
            </li>
            <li className="main-header__nav-item" style={{display: 'none'}}>
              <div className="main-header__nav-click">
                施設型定額制契約 <span className="accordion"></span>
              </div>
              <ul className="main-header__children" style={{display: window.location.pathname.includes("/facility/facility_agreements") ?'block' : '' }}>
                <li className={`main-header__children-item ${/\/facility\/facility_agreements\/index?$/.test(window.location.pathname) ? 'active' : ''}`}>
                  <Link to="/facility/facility_agreements/index">一覧</Link>
                </li>
                <li className={`main-header__children-item ${/\/facility\/facility_agreements\/customers(\/[\w-]*)?$/.test(window.location.pathname) ? 'active' : ''}`}>
                  <Link to="/facility/facility_agreements/customers">お客様登録情報変更申込</Link>
                </li>
                <li className={`main-header__children-item ${/\/facility\/facility_agreements\/terminate_cancels(\/[\w-]*)?$/.test(window.location.pathname) ? 'active' : ''}`}>
                  <Link to="/facility/facility_agreements/terminate_cancels">解約・キャンセル申込</Link>
                </li>
                <li className={`main-header__children-item ${/\/facility\/facility_agreements\/lost_non_warranty(\/[\w-]*)?$/.test(window.location.pathname) ? 'active' : ''}`}>
                  <Link to="/facility/facility_agreements/lost_non_warranty">紛失・保証外レンズ申込</Link>
                </li>
              </ul>
            </li>
            <li className="main-header__nav-item sp">
              <div className="main-header__nav-click">
                施設情報の確認・変更 <span className="accordion"></span>
              </div>
              <ul className="main-header__children">
                <li className="main-header__children-item"><Link to="/facility/confirm">施設情報の確認</Link></li>
                <li className="main-header__children-item"><Link to="/facility/change_mail">メールアドレス・パスワードの変更</Link></li>
              </ul>
            </li>
          </ul>
          <div className="sp">
            <Link to="" className="c-btn__01">お問い合わせ</Link>
            <div className="c-al--c">
              <Link to="" className="main-header__logout c-btn__02">ログアウト</Link>
            </div>
          </div>
          <div className="main-header__close sp"
            onClick={() =>{addClassHtml()}}
            onKeyPress={(e: any)=>{
              if(e.key==="Click") {addClassHtml()}
              }}
          >
            ✕　閉じる
          </div>
        </div>
      </header>
    </React.Fragment>
  )
}

export default React.memo(Header);